import { useEffect, useState } from 'react'

export default function useCurves(): Array<AssetCurves> {
    const [allCurves, setAllCurves] = useState([])
    useEffect(() => {
        const controller = new AbortController()
        const signal = controller.signal

        fetch('/services/plugin-liverig/curves/all', { signal })
            .then(e => e.json())
            .then(e => {
                const curves: Array<AssetCurves> = Object.entries(e).map(([mnemonic, entry]) => ({
                    ...entry,
                    mnemonic,
                    label: entry.description,
                    value: mnemonic
                }))
                setAllCurves([...curves].sort((a, b) => compare(a, b)))
            })
            .catch(e => console.error(e))

        return () => controller.abort()
    }, [])

    return allCurves
}

function compare(a, b): number {
    if (a.label < b.label) {
        return -1
    }
    if (a.label > b.label) {
        return 1
    }

    return 0
}
